import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { useLazyQuery } from "@apollo/client";

import { Form, Input } from "antd";
import { SyncOutlined } from "@ant-design/icons";

import { QUERY_STUDENT_PARENT1CITY } from "../../../../operations/queries/forms/SIS";
import SyncSISButton from "../../../elements/formItems/SyncSISButton";

const StudentParent1CitySIS = ({
  form,
  sis,
  id,
  initialValue,
  error,
  disabled = true,
}) => {
  const [studentSIS, setStudentSIS] = useState(initialValue);
  const [getSIS, { data, loading }] = useLazyQuery(QUERY_STUDENT_PARENT1CITY);

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ parent1City: data?.student.parent1City || "" });
    setStudentSIS(data.student.parent1City || "");
  }, [data]);

  return (
    <Form.Item
      label="Parent #1 City"
      name="parent1City"
      validateStatus={error ? "error" : ""}
      help={error}
    >
      <Input
        onChange={(e) => setStudentSIS(e.target.value)}
        disabled={disabled}
        addonAfter={
          <SyncSISButton
            loading={loading}
            sisValue={sis?.student.parent1City}
            currentValue={studentSIS}
          >
            <SyncOutlined onClick={() => getSIS({ variables: { id: id } })} />
          </SyncSISButton>
        }
      />
    </Form.Item>
  );
};

StudentParent1CitySIS.propTypes = {
  form: PropTypes.object.isRequired,
  initialValue: PropTypes.string.isRequired,
  sis: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  error: PropTypes.string,
  disabled: PropTypes.bool,
};

export default StudentParent1CitySIS;
